<template>
  <div :class="getClassName('user-reviews')">
    <div :class="getClassName('user-reviews__header')">
      <div :class="getClassName('user-reviews__summary')">レビュー</div>
      <div>
        <div :class="getClassName('stars')">
          <IconStar
            :class="[...getClassName('stars__items'), 'stars__items--average']"
            v-for="n in starMax"
            :key="'average' + n"
            :active="Math.floor(getAverage) >= n"
          />
        </div>
        <div :class="getClassName('user-reviews__average')">{{ starMax }}つ星のうち{{ getAverage }}</div>
      </div>
      <!-- <a
        :class="getClassName('user-reviews__show')"
        href="javascript:void(0)"
        @click="showReviews(visibleReviews)"
        v-if="getCount > 0"
      >
        <span :class="getClassName('user-reviews__count')">{{ getCount }}件</span>のカスタマーレビューを見る
      </a> -->
      <div :class="getClassName('user-reviews__show')">
        <span :class="getClassName('user-reviews__count')">{{ getCount }}件</span>のカスタマーレビュー
      </div>
    </div>

    <div :class="getClassName('user-reviews__container')" v-show="getCount > 0 || user !== null">
      <transition name="user-reviews__reviews-" v-show="getCount > 0">
        <div class="user-reviews__reviews" v-if="visibleReviews">
          <div :class="getClassName('review')" v-for="review in reviews" :key="review.id">
            <div :class="getClassName('review__header')">
              <!-- <div :class="getClassName('review__user')">
                {{ review.user.age }}／{{ review.user.gender_text }}
              </div>
              <div :class="getClassName('review__date')">{{ getDate(review) }}</div> -->
              <div :class="[...getClassName('review__stars'), ...getClassName('stars')]">
                <IconStar
                  :class="[...getClassName('stars__items'), 'stars__items']"
                  v-for="n in starMax"
                  :key="'review' + review.id + '-' + n"
                  :active="review.star >= n"
                />
              </div>
            </div>
            <div :class="getClassName('review__title')">{{ review.title }}</div>
            <div :class="getClassName('review__comment')" v-text="review.comment" />
            <div :class="getClassName('review__answer')" v-text="review.answer" v-if="review.answer" />
          </div>
        </div>
        <div class="user-reviews__reviews reviews-close" v-if="!visibleReviews">
          <div :class="getClassName('review')" v-for="review in reviews" :key="review.id">
            <div :class="getClassName('review__header')">
              <!-- <div :class="getClassName('review__user')">
                {{ review.user.age }}／{{ review.user.gender_text }}
              </div>
              <div :class="getClassName('review__date')">{{ getDate(review) }}</div> -->
              <div :class="[...getClassName('review__stars'), ...getClassName('stars')]">
                <IconStar
                  :class="[...getClassName('stars__items'), 'stars__items']"
                  v-for="n in starMax"
                  :key="'review' + review.id + '-' + n"
                  :active="review.star >= n"
                />
              </div>
            </div>
            <div :class="getClassName('review__title')">{{ review.title }}</div>
            <div :class="getClassName('review__comment')" v-text="review.comment" />
            <div :class="getClassName('review__answer')" v-text="review.answer" v-if="review.answer" />
          </div>
          <div class="user-reviews__more">
            <div class="user-reviews__wrap"></div>
            <p><a href="javascript:void(0)" @click="showReviews(visibleReviews)">もっと見る</a></p>
          </div>
        </div>
      </transition>

      <v-form :class="getClassName('form')" ref="edit" @submit.prevent="postReview" v-if="visibleReviewForm">
        <div :class="getClassName('form__value')">
          <div :class="getClassName('form__term')">評価</div>
          <div :class="getClassName('stars')">
            <a
              :class="[...getClassName('stars__items'), 'stars__items--form']"
              v-for="n in starMax"
              :key="'form' + n"
              @click="form.star = n"
              @mouseenter="form.star = n"
            >
              <IconStar
                :class="[...getClassName('stars__items'), 'stars__items--form']"
                :active="form.star >= n"
              />
            </a>
          </div>
        </div>
        <v-text-field :class="getClassName('form__field')" label="タイトル" v-model="form.title" />
        <v-textarea
          :class="getClassName('form__textarea')"
          label="コメント"
          auto-grow
          rows="1"
          v-model="form.comment"
        />
        <button :class="getClassName('form__button')" type="submit" :disabled="isFetching">投稿</button>
      </v-form>

      <div :class="getClassName('user-reviews__footer')" v-if="user !== null && !visibleReviewForm">
        <button :class="getClassName('user-reviews__button')" type="button" @click="visibleReviewForm = true">
          レビューを投稿する
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { APP_URL, API_URL } from '../../../config/const';
import { OK, CREATED, UNPROCESSABLE_ENTITY, ERROR_MESSAGES, numberFormat } from '../../../_modules/util';

import getClassName from '../../_mixins/getClassName';

import IconStar from '../images/IconStar';

export default {
  mixins: [getClassName],
  components: {
    IconStar,
  },
  props: {
    item: {
      type: Object,
      required: false,
      default: () => {},
    },
    user: {
      type: Object,
      required: false,
      default: () => {},
    },
    reviews: {
      type: Array,
      required: false,
      default: () => [],
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      starMax: 5,
      visibleReviews: false,
      visibleReviewForm: false,
      form: {
        title: '',
        star: 0,
        comment: '',
      },
      isFetching: false,
    };
  },
  computed: {
    getCount() {
      return this.reviews.length;
    },
    getAverage() {
      const digit = 10;
      const sum = this.reviews.reduce((prev, review) => prev + review.star, 0);

      if (sum === 0) return sum;

      return Math.round((sum / this.getCount) * digit) / digit;
    },
    getDate() {
      return (review) => this.$dayjs(review.created_at).format('YYYY/MM/DD');
    },
  },
  methods: {
    async postReview() {
      if (this.isFetching) return;
      if (!confirm('レビューを投稿します。\nよろしいですか？')) return;
      await this.switchFetching(true);
      const response = await axios.post(API_URL + '/items/post-review', {
        ...this.form,
        item_id: this.item.id,
        user_id: this.user.id,
      });

      if (response.status === OK) {
        this.form = {
          title: '',
          star: 0,
          comment: '',
        };
        this.visibleReviewForm = false;
        alert('レビューを投稿しました。');
        await this.switchFetching(false);
        return false;
      }

      if (response.status === UNPROCESSABLE_ENTITY) {
        this.$emit('alert', {
          varient: 'error',
          messages: Object.keys(response.data.errors).flatMap((key) => response.data.errors[key]),
        });
        await this.switchFetching(false);
        return false;
      }

      this.$emit('alert', {
        varient: 'error',
        messages: [ERROR_MESSAGES[response.status]],
      });

      await this.switchFetching(false);
    },
    switchFetching(bool) {
      this.isFetching = bool;
    },
    showReviews(bool) {
      if(bool){
        this.visibleReviews = false;
      }else{
        this.visibleReviews = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../_sass/variables';
@import '../../_sass/mixins';

.stars {
  display: flex;
  &__items {
    width: auto;
    height: 13px;
    &:not(:first-child) {
      margin-left: 7px;
    }
    &--average {
      height: 17px;
      &:not(:first-child) {
        margin-left: 8px;
      }
    }
    &--form {
      height: 20px;
      display: block;
      cursor: pointer;
      &:not(:first-child) {
        margin-left: 10px;
      }
    }
  }
}

.user-reviews {
  width: 850px;
  border: solid 1px $color__line--item;
  margin: 20px auto 0;
  letter-spacing: 0.03em;
  &--sp {
    width: 87.5%;
  }
  &__header {
    padding: 19px 24px 14px;
    display: flex;
    flex-flow: row wrap;
    &--sp {
      padding: 14px 12px;
    }
  }
  &__summary {
    width: 100%;
    margin-bottom: 26px;
    color: $color__title;
    font-size: 1.3rem;
    line-height: 1;
    flex: 1 1 auto;
    &--sp {
      font-size: 0.9rem;
      margin-bottom: 8px;
    }
  }
  &__average {
    @include small-text;
    margin-top: 20px;
    line-height: 1;
    flex: 0 0 auto;
    &--sp {
      margin-top: 20px;
      font-size: 0.9rem;
    }
  }
  &__show {
    @include small-text;
    margin-left: auto;
    color: $color__active;
    line-height: 1;
    flex: 0 0 auto;
    align-self: flex-end;
    &--sp {
      font-size: 0.9rem;
    }
  }
  &__count {
    font-size: 1.3rem;
    &--sp {
      font-size: 0.9rem;
    }
  }
  &__container {
    border-top: solid 1px $color__line--item;
  }
  &__reviews {
    // overflow: hidden;
    // max-height: 100vh;
    &--enter-active,
    &--leave-active {
      transition: max-height 0.5s ease 0s;
    }
    &--enter,
    &--leave-to {
      max-height: 0;
    }
  }
  &__reviews.reviews-close {
    overflow: hidden;
    max-height: 70vh;
    position: relative;
  }
  &__more {
    height: 153px;
    width: 100%;
    position: absolute;
    bottom: 0px;
    &--sp {
      width: 100%;
      height: 60px;
      font-size: 1.1rem;
    }
    p {
      height: 53px;
      font-size: 1.5rem;
      letter-spacing: 0.1em;
      line-height: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.1rem;
      background: #fff;
      &--sp {
        width: 100%;
        height: 30px;
        font-size: 1.1rem;
      }
    }
  }
  &__wrap {
    height: 100px;
    width: 100%;
    background: linear-gradient(transparent, #fff);
    &--sp {
      width: 100%;
      height: 30px;
      font-size: 1.1rem;
    }
  }
  &__footer {
    padding: 30px 24px 39px;
    &--sp {
      padding: 15px 12px 19px;
    }
  }
  &__button {
    background: $color__active;
    width: 375px;
    height: 48px;
    border-radius: 24px;
    margin-left: auto;
    color: #fff;
    font-size: 1.5rem;
    letter-spacing: 0.1em;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before {
      content: '';
      background: url(../images/icon_post-review.svg) no-repeat center center;
      background-size: 20.5px auto;
      width: 21px;
      height: 20px;
      margin-right: 3px;
      flex: 0 0 auto;
    }
    &--sp {
      width: 100%;
      height: 30px;
      border-radius: 15px;
      font-size: 1.1rem;
      &::before {
        content: '';
        background-size: 14px auto;
        width: 14px;
        height: 13px;
        margin-right: 6px;
      }
    }
  }
}

.review {
  width: 800px;
  margin: 20px auto 0;
  color: $color__title;
  &:not(:first-child) {
    padding-top: 24px;
    border-top: solid 1px $color__cell;
  }
  &:last-child {
    padding-bottom: 19px;
  }
  &--sp {
    width: calc(100% - 26.667px);
    &:not(:first-child) {
      padding-top: 19px;
    }
  }
  &__header {
    display: flex;
    flex-flow: row wrap;
  }
  &__user {
    @include small-text;
    line-height: 1;
    &--sp {
      font-size: 0.9rem;
    }
  }
  &__date {
    margin-left: auto;
    font-size: 1.1rem;
    line-height: 1;
    &--sp {
      font-size: 0.9rem;
    }
  }
  &__stars {
    width: 100%;
    margin-top: 10px;
    flex: 1 1 auto;
    &--sp {
      margin-top: 8px;
    }
  }
  &__title {
    margin-top: 25px;
    color: $color__title;
    &--sp {
      margin-top: 15px;
    }
  }
  &__comment {
    margin-top: 10px;
    line-height: 1.230769;
    white-space: pre-wrap;
    &--sp {
      margin-top: 0;
    }
  }
  &__answer {
    margin-top: 15px;
    line-height: 1.230769;
    display: flex;
    align-items: flex-start;
    white-space: pre-wrap;
    &::before {
      content: '';
      background: url(../images/icon_comment.svg) no-repeat center center;
      background-size: 20.5px auto;
      width: 21px;
      height: 20px;
      margin-right: 12px;
      flex: 0 0 auto;
    }
    &--sp {
      margin-top: 8px;
      display: block;
      &::before {
        content: '';
        background-size: 22px auto;
        width: 22px;
        height: 21px;
        margin-right: 0;
        margin-bottom: 8px;
        display: block;
      }
    }
  }
}

.form {
  width: 800px;
  margin: 30px auto 20px;
  &--sp {
    width: calc(100% - 26.667px);
    margin-top: 25px;
  }
  &__value {
    display: flex;
    align-items: center;
  }
  &__term {
    &::after {
      content: ':';
      margin: 0 0.5em;
    }
  }
  &__field {
    margin-top: 10px;
  }
  &__button {
    background: $color__active;
    width: 100px;
    height: 36px;
    padding: 10px;
    border-radius: 18px;
    box-sizing: border-box;
    color: #fff;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before {
      content: '';
      background: url(../images/icon_post-review.svg) no-repeat center center;
      background-size: 15px auto;
      width: 15px;
      height: 15px;
      margin-right: 3px;
      flex: 0 0 auto;
    }
  }
}
</style>
